import EspecialidadeModel from "@/models/cadastros/saude/EspecialidadeModel";
import { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import Api from "./Api";
import { servicosSaudeApiConfig } from "./config";

class ServicosSaudeFeriadoApi extends Api {
  constructor(config: AxiosRequestConfig) {
    super(config);
  }

  pesquisarFeriados(filtro: any): Promise<any> {
    return this.get("/feriados", {
      params: filtro,
    })
      .then((res) => {
        const { data } = res;
        return data;
      })
      .catch((err) => {
        throw err;
      });
  }
  obterFeriadoPorId(idFeriado: Number): Promise<any> {
    return this.get(`/feriados/${idFeriado}`)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error("Falha ao obter feriado.");
      });
  }

  deletarFeriado(idFeriado: Number): Promise<any> {
    return this.delete(`/feriados/${idFeriado}`)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error(error.response?.data.detail);
      });
  }

  atualizarFeriado(idFeriado: Number, feriado: any): Promise<string> {
    return this.put<any>(`/feriados/${idFeriado}`, feriado)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error(error.response?.data.detail);
      });
  }

  salvarFeriado(feriado: any): Promise<string> {
    return this.post<EspecialidadeModel>("/feriados", feriado)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error(error.response?.data.detail);
      });
  }
}

export const servicosSaudeFeriadoApi = new ServicosSaudeFeriadoApi(servicosSaudeApiConfig);
